import React, { ReactNode } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { Spinner } from 'front-end/src/components'

type InfiniteScrollProps<T> = {
  items: T[]
  children: (slicedItems: T[]) => ReactNode
  limit?: number
}

export function InfiniteScrollWrapper<T>({
  items,
  children,
  limit = 50
}: InfiniteScrollProps<T>) {
  const [slicedItems, setItemsSlice] = React.useState(() =>
    items.slice(0, Math.min(items.length, limit))
  )

  const loadMoreItems = () => {
    setItemsSlice(
      items.slice(0, Math.min(items.length, slicedItems.length + limit))
    )
  }

  React.useEffect(() => {
    setItemsSlice(items.slice(0, Math.min(items.length, limit)))
  }, [items])

  return (
    <InfiniteScroll
      loadMore={loadMoreItems}
      hasMore={items.length > slicedItems.length}
      loader={<Spinner />}
      useWindow={false}
    >
      {children(slicedItems)}
    </InfiniteScroll>
  )
}
